<template>
    <div id="task">
        <section class="content">
            <app-menu v-if="isLoggedIn"></app-menu>
            <div class="container-fluid">
                <div class="block-header">
                    <h2>Permissions List</h2>
                    <button type="button" class="btn general-button btn-info waves-effect m-r-20 pull-right icon-btn" id="submit" name="submit"
                            v-on:click.prevent="editRentalRage">
                        <i class="fa fa-plus" aria-hidden="true"></i>
                    </button>
                </div>

                <vue-good-table class="permissionList"
                                ref="listPermissionTable"
                                mode="remote"
                                title="Permissions"
                                @on-page-change="onPageChange"
                                @on-selected-rows-change="selectionChanged"
                                @on-column-filter="onColumnFilter"
                                @on-per-page-change="onPerPageChange"
                                @on-sort-change="onSortChange"
                                :totalRows="totalRecords"
                                :columns="columns"
                                :rows="rows"
                                :pagination-options="{
                                enabled: true,
                                mode: 'pages',
                                pageLabel: 'Page',
                                position: 'bottom',
                                perPage: 25,
                                setCurrentPage: serverParams.setCurrentPage,
                                perPageDropdown: [25, 50, 100, 200 ,500],
                                dropdownAllowAll: false,
                                }"
                                :search-options="{
                                enabled: false,

                                }"
                                >

                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'action'" class='btn-center-vvg'>
                                <!--class="btn btn-xs general-button btn-primary"-->
                                <router-link title='Edit permission' class="btn edit-btn-vvg waves-effect" v-bind:to="{name: 'EditPermissions',params:{id:props.row.id}}"><i class="material-icons">mode_edit</i></router-link>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                </vue-good-table>

            </div>
        </section>
    </div>
</template>

<script>
    import Vue from 'vue';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import {list_taskUrl} from '../../config';
    import FrontMenu from '@/components/partials/FrontMenu';
    import {addTask} from '../../config';
    import EventBus from '../event-bus';
    import SessioMixin from '../../mixins/sessionmixin';

    export default {
        name: "permissions",
        mixins: [SessioMixin],
        data: () => ({
                files: [],
                isLoggedIn: false,
                firstLoad: 0,
                columns: [
                    {
                        label: 'Name',
                        field: 'description',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Name", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter", //only trigger on enter not on keyup
                        }
                    },
                    {
                        label: 'Date',
                        field: 'created_at',
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM-DD-YYYY", // placeholder for filter input
                            filterValue: '', // initial populated value for this filter
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /*{
                     label: 'Guard Name',
                     field: 'guard_name',
                     filterable: true,
                     filterOptions: {
                     enabled: true, // enable filter for this column
                     placeholder: "Guard Name", // placeholder for filter input
                     filterValue: '', // initial populated value for this filter
                     trigger: "enter" //only trigger on enter not on keyup
                     }
                     },*/
                    {
                        label: 'Actions',
                        field: 'action',
                        html: true,
                        sortable: false,
                        thClass: 'disable-sorting',
                    },
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: 'name',
                        type: 'asc',
                    },
                    page: 1,
                    perPage: 25,
                    setCurrentPage: 1,
                },
            }),
        beforeMount: function () {
            var self = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
            }
        },
        mounted: function () {
            $(".removeActive").removeClass('active');
            $("#menupermission").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            // console.log(this.message);
            this.showLoader();
            this.loadPermissions();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        methods: {
            formatFn: function (value) {
                return `ITEM ${value}`;
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});

                this.loadPermissions();
            },
            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadPermissions();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field: ('name');
                    field: ('created_at');
                    field: ('guard_name');
                }
                ;
                this.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;

                if (this.firstLoad == 1 || filters.name || filters.created_at || filters.guard_name) {
                    this.loadPermissions();
                }

            },
            selectionChanged() {

                var self = this;
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            editRentalRage() {

                var self = this;
                // self.$router.push("/addtask");
                self.$router.push("/permissions/create");
            },
            onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params.sortType,
                        field: this.columns[params.columnIndex].field,
                        /*type: params[0].type,
                         field: params[0].field,*/
                    },
                });
                this.loadPermissions();
            },
            loadPermissions: function () {
                var self = this;
                //console.log(self.message);
                self.serverParams.setCurrentPage = self.serverParams.page;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort
                };
                this.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/permissions/list",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        self.rows = data.content.row;
                        if (data.code == '200') {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.showHidePagination("permissionList", self.totalRecords);
                        }
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }

                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }
                });

            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/rolePermission/ListPermissions.vue